import { render } from "./ExpenseReceiptDetail.vue?vue&type=template&id=4f39b216&scoped=true"
import script from "./ExpenseReceiptDetail.vue?vue&type=script&lang=js"
export * from "./ExpenseReceiptDetail.vue?vue&type=script&lang=js"

import "./ExpenseReceiptDetail.vue?vue&type=style&index=0&id=4f39b216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f39b216"]])

export default __exports__